import router from './pgRouter';
import '@/commons/language.js';
import '@/modules/device/importDevComponent.js';
import '@/modules/orgManage/importOrgComponent.js';
import '@/modules/personnelManage/importTreeStructure.js';
import '@/modules/workFlowManagement/importFlowComponent.js';
import regex from '@/commons/regex.js';
import common from '@/commons/common.js';
window.pangu = {
    regex: regex,
    common: common
};
window.app.modRouter.push(router);
let menuData = sessionStorage.getItem('menuData');
if (menuData) {
    router.mergeRoutes(JSON.parse(menuData), window.vue.$router.options.routes[1].children);
    window.vue.$router.addRoutes(window.vue.$router.options.routes);
}
